import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function CostCenterComponent({ entity }) {
  const costCenter = entity?.costCenter;
  if (!costCenter) return "";

  return (
    <Box
      height="100%"
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Typography variant="body2">
        {costCenter.costCenterName} {costCenter.costCenterCode}
      </Typography>
    </Box>
  );
}
